<template>
  <Menu ref="sideMenu" theme="light" width="auto" @on-select="handleChange">
          <Submenu v-for="item in menu" :key="item.id" :name="item.name" v-if="!item.parentAdminUserId || item.parentAdminUserId === user.parentAdminUserId">
          <template slot="title">
            <Icon type="ios-navigate"></Icon>
            {{ item.title }}
          </template>
          <div v-for="child in item.children" :key="child.id">
            <MenuItem v-if="!child.parentAdminUserId || child.parentAdminUserId === user.parentAdminUserId"  :name="child.name">{{ child.title }}</MenuItem>
          </div>
          </Submenu>
    </Menu>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'MainNav',
  computed: {
    ...mapState(['menu', 'user'])
  },
  data () {
    return {

    }
  },
  methods: {
    changeMenu (active) {
      this.$router.push(active)
    },
    handleChange (name) {
      let willpush = true
      if (this.beforePush !== undefined) {
        if (!this.beforePush(name)) {
          willpush = false
        }
      }
      if (willpush) {
        this.$router.push({
          name: name
        })
      }
      this.$emit('on-change', name)
    }
  },
  updated () {
    this.$nextTick(() => {
      if (this.$refs.sideMenu) {
        this.$refs.sideMenu.updateOpened()
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/MainNav.vue